// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__2s-zo","fadeIn":"NavigationItem_fadeIn__3XKla","enable":"NavigationItem_enable__aVfc9"};